export const ON_URL_CHANGE = 'lakeflow_on_url_change';